import React from 'react';
import {Radar} from 'react-chartjs-2';
import {Box, Skeleton} from '@mui/material';
import {Chart as ChartJS, Filler, Legend, LineElement, PointElement, RadialLinearScale, Tooltip,} from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const RadarChart = ({data, isLoading}) => {

    const wrapLabel = (label, maxLen = 20) => {
        if (!label || label.length <= maxLen) return label;
        const words = label.split(' ');
        let currentLine = "";
        const lines = [];
        words.forEach(word => {
            if ((currentLine + word).length > maxLen) {
                lines.push(currentLine.trim());
                currentLine = word + " ";
            } else {
                currentLine += word + " ";
            }
        });
        if (currentLine.trim()) lines.push(currentLine.trim());
        return lines;
    };

    let processedLabels = [];
    let maxLineLength = 0;
    if (data && data.labels) {
        processedLabels = data.labels.map(label => {
            const wrapped = wrapLabel(label, 20);
            const lines = Array.isArray(wrapped) ? wrapped : [wrapped];
            lines.forEach(line => {
                if (line.length > maxLineLength) maxLineLength = line.length;
            });
            return wrapped;
        });
    }

    const modifiedData = data ? {...data, labels: processedLabels} : data;

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            r: {
                angleLines: {
                    color: '#ccc',
                },
                grid: {
                    color: '#e5e5e5',
                    circular: true,
                    lineWidth: 1,
                },
                ticks: {
                    stepSize: 20,
                    color: '#333',
                    backdropColor: 'transparent',
                },
                pointLabels: {
                    font: {
                        size: 14,
                        weight: 'regular',
                    },
                    color: '#555',
                },
                suggestedMin: 0,
                suggestedMax: 5,
                backgroundColor: '#fff',
            },
        },
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: false,
                    pointStyle: "roundRect",
                    padding: 20,
                    generateLabels: (chart) => {
                        return chart.data.datasets.map((dataset, i) => ({
                            text: dataset.label,
                            fillStyle: dataset.borderColor,
                            fontColor: dataset.borderColor,
                            strokeStyle: dataset.borderColor,
                            lineWidth: 2,
                            hidden: !chart.isDatasetVisible(i),
                            index: i,
                        }));
                    },
                    font: {
                        size: 14,
                    },
                    color: '#333',
                },
                reverse: true,
            },
        },
    };

    return (
        <Box>
            <Box sx={{height: '460px', width: '100%'}}>
                {isLoading ? (
                    <Skeleton
                        variant="rectangular"
                        width="80%"
                        height="80%"
                        sx={{
                            bgcolor: "grey.200",
                            borderRadius: "4px",
                        }}
                    />
                ) : data && data.labels && data.labels.length > 0 ? (<Radar data={modifiedData} options={options}/>) : (
                    <h3>No Data Available</h3>
                )}
            </Box>
        </Box>
    );
};

export default RadarChart;
